//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { HEADER, MOBILE, TABLET } from '@/scripts/constants/media-query'

export default {
  name: 'rb-header-product-carousel',
  data() {
    return {
      nextNavButton: undefined,
      prevNavButton: undefined,
      slidesPerView: 6,
      slidesPerGroup: 6,
      currentGroup: 1,
    }
  },
  computed: {
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET || this.$mq === HEADER
    },
    totalSlides() {
      return this.$slots.content.filter((slot) => slot.tag)?.length ?? 0
    },
    totalGroups() {
      if (this.totalSlides === 0) return 1

      return Math.ceil(this.totalSlides / this.slidesPerGroup)
    },
  },
  mounted() {
    this.nextNavButton = this.$refs['nextNavigation']
    this.prevNavButton = this.$refs['prevNavigation']
  },
  methods: {
    incrementCurrentGroup() {
      this.currentGroup += 1
    },
    decrementCurrentGroup() {
      this.currentGroup -= 1
    },
  },
}
